<template>
    <section class="shop_both_area">
            <div class="container">
                <div class="row">
                    <div class="col-sm-3">
                        <menu-view></menu-view>
                        <filter-view :propertyGroups="[]" :sc="{}" @filterChanged="categorySelected"></filter-view>
                    </div>

                    <transition name="fade">
                        <router-view></router-view>
                    </transition>
                </div>
            </div>
        </section>
</template>

<script >
import JS from './Dashboard.js'
import Filter from '@pages/list/Filter.vue'

export default{
    mixins:[JS],
    components:{
        FilterView:Filter
    },
    methods:{
        categorySelected:function (search) {
            this.$router.push('/list?filter='+this.createNavigationUrl(search.categoryId));
        },
        createNavigationUrl(catId,pgId,propId){
            // if (!catId){
            //     catId = this.product.parentCategory.id;
            // }
            var o = {
                categoryId: catId,
            }
            if (pgId && propId){
                o.propertyGroups=[{
                    propertyGroupId: pgId,
                    properties:[propId]
                }]
            }
            return btoa(JSON.stringify(o));
        }
    }
}
</script>



// WEBPACK FOOTER //
// Dashboard.vue?b7fd3490